export default __webpack_public_path__ + "static/media/Hibiscus Conditioner - Back - (S-11)1.c389c393.jpg";